/* eslint-disable jsx-a11y/anchor-is-valid */
import thumbnail from "../../../../assets/images/thumbnail.png";
import asset6 from "../../../../assets/images/asset6.png";
import { SHOP } from "../../../../config/config";
import getSymbolFromCurrency from "currency-symbol-map";
import { events } from "../../../../hooks/config";
import useGAEventTracker from "../../../../hooks/useGAEventTracker";

const RecommendProduct = ({ product }) => {
  const { category, action, label } = events.productRecommend;
  const GAEventsTracker = useGAEventTracker(category);
  const addSpaceUppercase = (text) => text.replace(/([A-Z])/g, " $1").trim();
  return (
    <>
      <a
        className="card"
        style={{ width: "180px", textDecoration: "none" }}
        onClick={() => {
          GAEventsTracker(action, `${label} ${product?.title}`);
        }}
        href={"https://" + SHOP + "/products/" + product?.handle}
        target="_blank"
        rel="noreferrer"
      >
        <div
          style={{
            backgroundImage: `url(${
              product.image?.length ? product.image : asset6
            })`,
          }}
          className="card-img-top"
          alt="..."
        />
        <div className="card-body">
          <h5
            className="card-title"
            style={{
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            {addSpaceUppercase(product?.title)}
          </h5>
          <p className="card-text">
            {getSymbolFromCurrency(product.currency) + product?.price}
          </p>
        </div>
      </a>
    </>
  );
};

export default RecommendProduct;
